import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagic = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6911 5.13644L4.81849 12.9702C4.10866 13.6766 3.01165 13.6766 2.36636 12.9702C1.65653 12.2639 1.65653 11.1723 2.36636 10.5302L10.1745 2.6964C10.8843 1.99007 11.9813 1.99007 12.6266 2.6964C13.3364 3.40273 13.3364 4.49432 12.6911 5.13644Z",
			stroke: "#156EFF",
			strokeWidth: 1.33333,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.0557 7.52332L4.8324 12.7466C4.17199 13.407 3.15135 13.407 2.55097 12.7466C1.89056 12.0862 1.89056 11.0655 2.55097 10.4652L7.77424 5.2419L10.0557 7.52332Z",
			fill: "#156EFF",
			stroke: "#156EFF",
			strokeWidth: 1.33333,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2751 8.11428C14.6433 8.11428 14.9417 7.8158 14.9417 7.44761C14.9417 7.07942 14.6433 6.78094 14.2751 6.78094C13.9069 6.78094 13.6084 7.07942 13.6084 7.44761C13.6084 7.8158 13.9069 8.11428 14.2751 8.11428Z",
			fill: "#156EFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4665 9.92762C12.8347 9.92762 13.1331 9.62914 13.1331 9.26095C13.1331 8.89276 12.8347 8.59428 12.4665 8.59428C12.0983 8.59428 11.7998 8.89276 11.7998 9.26095C11.7998 9.62914 12.0983 9.92762 12.4665 9.92762Z",
			fill: "#156EFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5007 10.1219C14.8688 10.1219 15.1673 9.82342 15.1673 9.45523C15.1673 9.08704 14.8688 8.78856 14.5007 8.78856C14.1325 8.78856 13.834 9.08704 13.834 9.45523C13.834 9.82342 14.1325 10.1219 14.5007 10.1219Z",
			fill: "#156EFF"
		})
	]
});
const ForwardRef = forwardRef(SvgMagic);
export default ForwardRef;
